import { render, staticRenderFns } from "./chartBox.vue?vue&type=template&id=5848afb8&"
import script from "./chartBox.vue?vue&type=script&lang=js&"
export * from "./chartBox.vue?vue&type=script&lang=js&"
import style0 from "./chartBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports